import { render } from "./MoneyTransaction.vue?vue&type=template&id=05c791c0&scoped=true&ts=true"
import script from "./MoneyTransaction.vue?vue&type=script&lang=ts"
export * from "./MoneyTransaction.vue?vue&type=script&lang=ts"

import "./MoneyTransaction.vue?vue&type=style&index=0&id=05c791c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c791c0"]])

export default __exports__